import ObjectService from '@/vuex/modules/history/ObjectService'

const TRACKED_ATTRIBUTES_SLIDES = ['id', 'title', 'deleted', 'order']

const historyPlugin = (store) => {
  let isWatching = false

  const getSimplifiedSlides = (slides) => {
    return ObjectService.prune(slides, TRACKED_ATTRIBUTES_SLIDES)
  }

  const setupWatchers = () => {
    if (isWatching) return
    store.watch(
      (state) => ({
        slides: state.presentation?.slides,
        activeSlide: state.slideActive,
        simplifiedSlides: state.presentation?.slides ?
          getSimplifiedSlides(state.presentation.slides) : null,
      }),
      ({ slides, activeSlide, simplifiedSlides }) => {
        if (!slides || !activeSlide || !simplifiedSlides) return
        store.dispatch('history/snapshotSlidesAction', {
          slideId: activeSlide?.id,
          slides,
          simplifiedSlides,
        })
      },
      { deep: true },
    )

    isWatching = true
  }

  // Subscribe to relevant actions
  store.subscribeAction((action) => {
    if (action.type === 'setPresentation') {
      setupWatchers()
    }

    if (action.type === 'presentationReport/clearPresentationReportAction') {
      store.dispatch('history/clearHistoryAction')
      isWatching = false
    }
  })
}

export default historyPlugin
